import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Helper files for API calls
import { getFirebaseBackend } from "../../../helpers/firebase_helper";

import AuthService from "../../../services/authService";
const fireBaseBackend = getFirebaseBackend();

// Async thunks for login and logout
export const loginClub = createAsyncThunk(
  "auth/loginClub",
  async ({ user, history }, { rejectWithValue }) => {
    try {
      const response = await AuthService.login(user, "club");
      const token = response.data.accessToken;
      console.log("token " + token);
      const refresh_token = response.data.refreshToken;
      localStorage.setItem("authUser", token);
      localStorage.setItem("role", "club");

      history("/dashboard");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const loginAgent = createAsyncThunk(
  "auth/loginAgent",
  async ({ user, history }, { rejectWithValue }) => {
    try {
      const response = await AuthService.login(user, "agent");
      const token = response.data.accessToken;
      const refresh_token = response.data.refresh_token;
      localStorage.setItem("authUser", token);
      localStorage.setItem("role", "agent");

      history("/dashboard");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (history, { rejectWithValue }) => {
    try {
      localStorage.removeItem("authUser");

      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        await fireBaseBackend.logout();
      }
      localStorage.removeItem("role");
      history("/login");
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Initial state
const initialState = {
  club: null,
  agent: null,
  loading: false,
  error: null,
};

// Slice
const loginSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // Add any synchronous reducers if needed
  },
  extraReducers: (builder) => {
    // Login
    builder
      .addCase(loginClub.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginClub.fulfilled, (state, action) => {
        state.loading = false;
        state.club = action.payload.club;
      })
      .addCase(loginClub.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(loginAgent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAgent.fulfilled, (state, action) => {
        state.loading = false;
        console.log("loginAgent payload :", action.payload);
        state.agent = action.payload.data;
      })
      .addCase(loginAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.data;
      });

    // Logout
    builder
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.loading = false;
        state.club = null;
        state.agent = null;
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default loginSlice.reducer;
